import {
  useQuery,
  UseQueryResult,
  UseQueryOptions,
} from '@tanstack/react-query';

import { queryKeys } from 'api/config';
import { useQueryHTTPRequest } from 'api/hooks/useHTTPRequest';

import {
  ChallengeTimelineItemType,
  IChallengeTimelineItem,
  INonRepeatedChallengeProps,
  NonRepeatedChallengeTimelineItem,
  NonRepeatedTargetType,
  RepeatedChallengeTimelineItem,
} from 'features/challenge/ChallengeTimelineItem';
import { useUserId } from 'features/user/hooks/useUserId';

export const usePlanningBacklogQuery = (
  options?: UseQueryOptions<
    { items: ChallengeTimelineItemType[] },
    unknown,
    { items: ChallengeTimelineItemType[] }
  >
): UseQueryResult<{ items: ChallengeTimelineItemType[] }, unknown> => {
  const { request } = useQueryHTTPRequest();
  const userId = useUserId();

  return useQuery<
    { items: ChallengeTimelineItemType[] },
    unknown,
    { items: ChallengeTimelineItemType[] }
  >(
    [queryKeys.backlog, userId],
    async () => {
      const response = await request({
        url: `/api/backlog/challenges?user_id=${userId}`,
      });

      return {
        items:
          response.challenges?.map(
            (challenge: IChallengeTimelineItem | INonRepeatedChallengeProps) =>
              (challenge.target as NonRepeatedTargetType)?.dueDate
                ? new NonRepeatedChallengeTimelineItem({
                    ...challenge,
                  } as NonRepeatedChallengeTimelineItem)
                : new RepeatedChallengeTimelineItem({
                    ...challenge,
                  } as RepeatedChallengeTimelineItem)
          ) || [],
      };
    },
    {
      staleTime: 20 * 1000,
      enabled: !!userId && options?.enabled,
      ...options,
    }
  );
};
